import { GraphQLClient } from 'graphql-request';
import config from '../../Config/Environment';
import { clearToken, getToken } from '../../Utils/Token';

const AUTH_ERROR_CODES = new Set(['UNAUTHORIZED', 'USER_NOT_FOUND']);

const buildClient = () => {
  const token = getToken();
  if (!token) return new GraphQLClient(`${config.endpoint}/`);
  return new GraphQLClient(`${config.endpoint}/`, {
    headers: { authorization: `Bearer ${token}` },
  });
};

/**
 * Normalize a graphql-request `ClientError` so callers get a stable shape
 * regardless of which authz path the backend took. See `src/Api/graphql.js`
 * for the full contract.
 */
const normalizeError = e => {
  const first = e?.response?.errors?.[0];
  const errorCode = first?.extensions?.code ?? null;
  const errorMessage = first?.message ?? e?.message ?? 'GraphQL request failed';

  if (errorCode && AUTH_ERROR_CODES.has(errorCode)) {
    clearToken();
  }

  return { error: true, errorCode, errorMessage };
};

const graphql = async (query, variables) => {
  const graphQLClient = buildClient();
  return graphQLClient.request(query, variables).catch(normalizeError);
};

export default graphql;
